import NewProposalModal from './NewProposalModal';
export default NewProposalModal;
